// extracted by mini-css-extract-plugin
module.exports = {"unit-count-type":"UnitCountInfo_unit-count-type__8SdtQ","unit-count-text":"UnitCountInfo_unit-count-text__KKP_f"};